import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type DetalleTablaDesarrollo = {
    idTablaDesarrollo?: number | null
}

const DetalleTablaDesarrolloContext = createContext<DetalleTablaDesarrollo>({});
const DetalleTablaDesarrolloUpdaterContext = createContext<(data: DetalleTablaDesarrollo) => void>(() => { });

export const useDetalleTablaDesarrollo = () => useContext(DetalleTablaDesarrolloContext);
export const useDetalleTablaDesarrolloUpdater = () => useContext(DetalleTablaDesarrolloUpdaterContext);

export const DetalleTablaDesarrolloProvider = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();
    const [data, setData] = useState<DetalleTablaDesarrollo>({});

    useEffect(() => {
        console.log("CAMBIANDO LOCATION EN DETALLE TABLA DESARROLLO")
        console.log(location.state)
        if (location.state?.idTablaDesarrollo) {
            console.log("CAMBIO REALIZADO EN DETALLE TABLA DESARROLLO")
            setData(location.state);
        }
    }, [location.state]);

    return (
        <DetalleTablaDesarrolloContext.Provider value={data}>
            <DetalleTablaDesarrolloUpdaterContext.Provider value={setData}>
                {children}
            </DetalleTablaDesarrolloUpdaterContext.Provider>
        </DetalleTablaDesarrolloContext.Provider>
    );
}